import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for AuditRoot component
 */
export const useAttributesRootStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(3),
        overflow: 'auto',
    },
    loadingState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(8),
    },
    // Summary View Styles
    summaryCard: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        border: '1px solid #e0e0e0',
    },
    summaryAttributeName: {
        fontWeight: 600,
        fontSize: '1rem',
        minWidth: 200,
        marginRight: theme.spacing(3),
    },
    badgeContainer: {
        display: 'grid',
        gridTemplateColumns: '100px 100px 100px',
        gap: theme.spacing(1),
        alignItems: 'center',
    },
    badgeSlot: {
        display: 'flex',
        justifyContent: 'center',
    },
    extractBadge: {
        backgroundColor: '#4caf50',
        color: 'white',
    },
    displayBadge: {
        backgroundColor: '#2196f3',
        color: 'white',
    },
    financialBadge: {
        backgroundColor: '#9c27b0',
        color: 'white',
    },
    unmatchedAttribute: {
        backgroundColor: '#fff3e0',
        borderColor: '#ffb74d',
    },
    // Edit Mode Styles
    attributeCard: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        width: '100%',
        boxSizing: 'border-box',
    },
    attributeName: {
        fontWeight: 600,
        fontSize: '1rem',
        marginRight: theme.spacing(3),
        minWidth: 200,
    },
    attributePrompt: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        minWidth: 250,
        marginRight: theme.spacing(2),
    },
    controlsGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    toggleControl: {
        marginRight: theme.spacing(1),
        marginLeft: 0,
    },
    toggleLabel: {
        fontSize: '0.875rem',
        userSelect: 'none',
    },
}))

export const useAttributesTabHeaderStyles = makeStyles((theme: Theme) => ({
    headerContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    topRow: {
        display: 'flex',
        gap: theme.spacing(3),
        alignItems: 'stretch',
    },
    legendContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        flex: '0 0 auto',
        padding: theme.spacing(2),
        backgroundColor: '#f5f5f5',
        border: '1px solid #e0e0e0',
        borderRadius: theme.shape.borderRadius,
    },
    legendTitle: {
        fontWeight: 600,
        fontSize: '0.875rem',
        marginBottom: theme.spacing(1),
    },
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    legendChip: {
        minWidth: 90,
    },
    legendDescription: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
    },
    extractBadge: {
        backgroundColor: '#4caf50',
        color: 'white',
    },
    displayBadge: {
        backgroundColor: '#2196f3',
        color: 'white',
    },
    financialBadge: {
        backgroundColor: '#9c27b0',
        color: 'white',
    },
    unmatchedNote: {
        padding: theme.spacing(2),
        backgroundColor: '#fff3e0',
        border: '1px solid #ffb74d',
        borderRadius: theme.shape.borderRadius,
        flex: 1,
    },
    unmatchedTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        color: '#e65100',
        fontSize: '0.9375rem',
    },
    unmatchedDescription: {
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    unmatchedList: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: theme.spacing(0.75),
        margin: 0,
        padding: 0,
        listStyle: 'none',
        marginBottom: theme.spacing(1),
    },
    unmatchedListItem: {
        fontSize: '0.875rem',
        fontWeight: 500,
        '&:before': {
            content: '"• "',
            marginRight: theme.spacing(0.5),
        },
    },
    unmatchedFooter: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
    },
    buttonSection: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: theme.spacing(2),
    },
}))
